export const EpicScreen = () => {
  return <h1>Epic</h1>
}